import The27types from './The27types.svelte';

const the27types = new The27types({
	target: document.body,
	props: {
	}
});

export default the27types;